export function chatMessageAttachmentIdentifiers(attachments = []) {
    return (Array.isArray(attachments) ? attachments : [attachments])
        .filter(Boolean)
        .map((attachment) => (
            attachment && typeof attachment === "object"
                ? attachment.documentId ?? attachment.id
                : attachment
        ))
        .filter((identifier) => identifier !== null && identifier !== undefined && identifier !== "");
}
